import {Box, Button, Field, Heading, Input, Show, Table, Text} from "@chakra-ui/react";
import React, {useCallback, useMemo, useState} from "react";
import {downloadLinkProcessor, openFile} from "../../components/hooks/FileLoader";

export interface FileExt {
    id: number | null,
    name: string,
    file: File | null,
}

export const FileListUploader = (props: {
    items: FileExt[],
    setItems: (value: (((prevState: FileExt[]) => FileExt[]) | FileExt[])) => void
}) => {
    // const [items, setItems] = useState<FileExt[]>([...props.files]);
    const [showForm, setShowForm] = useState<boolean>(false);
    const inputDefault: FileExt = useMemo(() => {
        return {
            id: null,
            name: "file",
            file: null,
        }
    }, []);
    const [inputParams, setInputParams] = useState<FileExt>(inputDefault);

    const fileDelete = useCallback((it: FileExt) => {
        if (!it)
            return;
        props.setItems(prev => {
            return prev.filter(o => o.name !== it.name);
        });
    }, [props]);

    const fileDownload = useCallback((it: FileExt) => {
        if (!it)
            return;
        downloadLinkProcessor(it.name, {data: it.file});
    }, []);

    const createOrUpdate = useCallback(() => {
        props.setItems(prev => {
            let lst = [...prev];
            let f = lst.find(o => o.name === inputParams.name);
            if (f) {
                lst[lst.indexOf(f)] = inputParams;
            } else {
                lst.push(inputParams);
            }
            return lst;
        });
        setShowForm(false);
    }, [props, inputParams]);

    const prepareInput = useCallback((item: FileExt | null) => {
        setInputParams({
            id: item ? item.id : null,
            name: item ? item.name : "file",
            file: null,
        });
    }, []);

    return (
        <Box borderWidth={1} borderColor="gray">
            {/*<Stack width="full" gap="5">*/}
            <Show when={showForm}>
                <Heading size="xl">Файл {inputParams.id}</Heading>
                <Box borderWidth={1} borderColor="gray">
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>Имя <Field.RequiredIndicator/></Field.Label>
                        <Input type="text" placeholder="Имя"
                               value={String(inputParams.name)}
                               onChange={(it) => setInputParams((prev) => {
                                   return {...prev, name: it.target.value}
                               })}/>
                    </Field.Root>
                    <Field.Root orientation="horizontal" required>
                        <Field.Label>File loader <Field.RequiredIndicator/></Field.Label>
                        <Text>{inputParams.file?.name}</Text>
                        <Button borderRadius={0}
                                onClick={e => {
                                    openFile(null, file => {
                                        setInputParams((prev) => {
                                            return {...prev, file: file, name: file.name};
                                        });
                                    })
                                }}>
                            Load
                        </Button>
                    </Field.Root>
                    <Button borderRadius={0} variant="solid" colorScheme="teal" width="full"
                        // disabled={!editable}
                            onClick={e => createOrUpdate()}>
                        {inputParams.id ? "Сохранить" : "Создать"}
                    </Button>
                </Box>
            </Show>
            <Heading size="xl">Файлы</Heading>
            <Box>
                <Button
                    // disabled={!editable}
                    onClick={e => {
                        if (showForm) {
                            setShowForm(false);
                        } else {
                            prepareInput(null);
                            setShowForm(true);
                        }
                    }}>
                    Создать новый
                </Button>
            </Box>
            <Table.Root size="sm" variant="outline" striped>
                <Table.Header>
                    <Table.Row>
                        <Table.ColumnHeader>Имя</Table.ColumnHeader>
                        <Table.ColumnHeader>Размер</Table.ColumnHeader>
                        <Table.ColumnHeader>Действия</Table.ColumnHeader>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.items.map((item) => (
                        <Table.Row key={item.name}>
                            <Table.Cell>{item.name}</Table.Cell>
                            <Table.Cell>{item.file ? item.file.size : 0}</Table.Cell>
                            <Table.Cell>
                                <Button onClick={e => fileDownload(item)}>
                                    Скачать
                                </Button>
                                {/*<Show when={editable}>*/}
                                <Button onClick={e => fileDelete(item)}>Удалить</Button>
                                {/*</Show>*/}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table.Root>
            {/*</Stack>*/}
        </Box>
    );
};